import React, { Fragment, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../redux/hook'
import { KTSVG } from '../../../../../../../../_metronic/helpers'
import { useGetAllWidgetsQuery } from '../../../../../../../redux/slices/widget/apiWidgetSlice'
import { Element, IMAGEDURATION, Source } from '../../../../../../../redux/slices/content/contentModels'
import { setContentSource } from '../../../../../../../redux/slices/content/contentSlice'
import { Widget } from '../../../../../../../redux/slices/widget/widgetModel'
import { extractYouTubeVideoId, getSectionIcon } from '../../../../../../../redux/slices/editor/editorModels'
import Swal from 'sweetalert2'
import moment from 'moment'
import { setCurrWidget } from '../../../../../../../redux/slices/editor/editorSlice'

type Props = {  
    className?: string
}

const LIST_PRIORITY = ["clock", "date", "time"];
const LIST_INTEGRATION = ["dashboard", "zoom", "api integration", "reward gateway", "external data source"];

const ADDITIONAL_WIDGETS = [
  {
    assets  : null,
    category: 100,
    code    : "<html></html>",
    id      : "AzR813OVlw",
    media   : null,
    name    : "Dashboard",
    parameter : {
      width: '150',
      height: '150'
    }
  },
  {
    assets  : null,
    category: 100,
    code    : "<html></html>",
    id      : "AzR813OVlw",
    media   : null,
    name    : "Zoom",
    parameter : {
      width: '150',
      height: '150'
    }
  },
  {
    assets  : null,
    category: 100,
    code    : "<html></html>",
    id      : "AzR813OVlw",
    media   : null,
    name    : "API Integration",
    parameter : {
      width: '150',
      height: '150'
    }
  },
  {
    assets  : null,
    category: 100,
    code    : "<html></html>",
    id      : "AzR813OVlw",
    media   : null,
    name    : "Reward Gateway",
    parameter : {
      width: '150',
      height: '150'
    }
  },
  {
    assets  : null,
    category: 100,
    code    : "<html></html>",
    id      : "AzR813OVlw",
    media   : null,
    name    : "External Data Source",
    parameter : {
      width: '150',
      height: '150'
    }
  }     
];

export const ModalSelectWidget: React.FC<Props> = ({className=""}) => {

  const breakpoints = {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
  }

  const getColumns = (width: number) => {
      if (width < breakpoints.sm) {
          return 2
      } else if (width < breakpoints.md) {
          return 3
      } else if (width < breakpoints.lg) {
          return 4
      } else if (width < breakpoints.xl) {
          return 4
      } else {
          return 4
      }
  }

  const dispatch = useAppDispatch()

  // const { data: rootFolders, isLoading: isLoadingFolders, isFetching: isFetchingFolders} = useGetAllRootFoldersQuery(5, { refetchOnMountOrArgChange: true }) 
  // const { data: allMedias, isLoading, isFetching} = useGetAllMediasQuery(5, { refetchOnMountOrArgChange: true })
  
  const { data: allWidgets, isLoading: isLoadingWidget } = useGetAllWidgetsQuery(5, { refetchOnMountOrArgChange: true })  
  // console.log("allWidgets: ", allWidgets);
  
  const currContentPersistor = useAppSelector(state => state.persistor._content.currContent)
  const currSectId = useAppSelector(state => state.content.currSectionId)  
  // const currentFolder = useAppSelector(state => state.editor.currentFolder) 

  // console.log("currContentPersistor: ", currContentPersistor);

    
  // const [defaultFolderIndex, setDefaultFolderIndex] = useState(-1)
  // const [grpName, setGrpName] = useState(currentFolder.group_name)
  const [columns, setColumns] = useState(getColumns(window.innerWidth))
  
  // const [imgError, setImgError] = useState<number[]>([])
  // const [vidError, setVidError] = useState<number[]>([])
  // const [loadAttempt, setLoadAttemp] = useState(0)

  // const selMediaSrcIds = useAppSelector(state => state.editor.selectedMediaSrcIds)  
  
  
  /**
   * Need to handle selected source ids outside the modal
   * i.e. drag-drop, deleted from section layer, edit existing content.
   * 
   */
  /*
  function setupSelectedSourceIds()
  {
    currContentPersistor.elements.map((sect, index) => {
      if(currSectId == sect.element_id)
      {
        sect.sources.map((source, i)=>{
          if(!arrSourceIds.includes(source.source_id))
          {
            arrSourceIds.push(source.source_id);
          }
        })
      }
    })
  }

  useEffect(() =>{
    setupSelectedSourceIds();
    setAssignSourceIds(arrSourceIds)
  }, [currContentPersistor])
  */
  
  // ----------------------------------
  const updatedimensions = () => {
      setColumns(getColumns(window.innerWidth))
  }


  // ---------------------------------------
  const addNewSource = (selectedWidget: Widget, recentSect: Element | undefined, extraParams : any = {}) => {
    
    var sourceList: Source[] = []
    var sourceOrder: number = 1
    recentSect?.sources.map((src)=>{
      sourceList =[...sourceList, {...src, order: src.order}]
      if(sourceOrder <= src.order) sourceOrder = src.order+1
    })  

    // create new source for widget
    // -----------------------------
    var newSource: Source = {
      source_list_id: Math.random().toString(36).slice(0,12).replace('0.', '').toUpperCase(),
      element_id: Math.random().toString(36).slice(0,12).replace('0.', '').toUpperCase(),
      source_id: "",
      order:  sourceOrder++,
      duration_override: -1, 
      // param_source: newParamSrc,     
      // // param_source : [{
      // //   delay: 0,
      // //   duration: (itemList[ind].duration>0 ? itemList[ind].duration : IMAGEDURATION),
      // //   volume: null,

      // //   bg_color:  sourceList.length> 0 ? sourceList[0].param_source[0].bg_color : "#00000000",
      // //   fill_to:   sourceList.length> 0 ? sourceList[0].param_source[0].fill_to: "",
      // //   alignment: sourceList.length> 0 ? sourceList[0].param_source[0].alignment: ""
      // // }],
      
      source: null,
      type: "widget",          
      param_source: [{
          type      : "widget",              
          widget_id : selectedWidget.id,
          title     : selectedWidget.name.toLowerCase(),
          paramValue: [{
            ...selectedWidget.parameter,
            ...extraParams,                            
          }],

          duration  : IMAGEDURATION,
          delay     : 0,
          volume    : null,

          bg_color  : sourceList.length> 0 ? sourceList[0].param_source[0].bg_color : "#00000000",
          fill_to   : sourceList.length> 0 ? sourceList[0].param_source[0].fill_to: "fit",
          alignment : sourceList.length> 0 ? sourceList[0].param_source[0].alignment: "center"
          // fill_to:   "fit",
          // alignment: "center"
      }]
    }
    
    sourceList = [newSource, ...sourceList ] //do not use push
    
    console.log("sourceList:", sourceList);

    dispatch(setContentSource(sourceList)) 
  }


  // ---------------------------------------
  const addSelectedWidget = (selectedWidget: Widget) => {
      var arrItems: any[] = []
      let inputData = "";
      let arrList: any = [];
      arrList["weather"]          = {input: "text", title: "Location",    inputValue: "Melbourne", placeholder: "Enter a location"}
      arrList["weather forecast"] = {input: "text", title: "Location",    inputValue: "Melbourne", placeholder: "Enter a location"}
      arrList["qr code"]      = {input: "text", title: "URL",         inputValue: "https://superbolt.com.au", placeholder: "Enter an URL"}        
      arrList["count down"]   = {input: "text", title: "Target Date", inputValue: moment().format("YYYY-MM-DD"), placeholder: "Enter a date (YYYY-MM-DD)"}        
      arrList["youtube"]      = {input: "text", title: "Youtube URL"}          
      arrList["google sheet"] = {input: "text", title: "Sheet ID"}  
      // ----------------------

      const recentSect = currContentPersistor.elements.find((ele)=> {return ele.element_id === currSectId})
      // console.log("recentSect:", recentSect)
      

      // Init extraParams
      let extraParams: any =  { 
        width: recentSect?.w, 
        height: recentSect?.h
      }
      // -----------------------                
      
      if (["weather", "weather forecast", "qr code", "count down", "youtube", "google sheet"].includes(selectedWidget.name.toLowerCase())){
        Swal.fire({
            // title: 'Video ID',
            // input: 'text',
            ... arrList[selectedWidget.name.toLowerCase()],

            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: "#ff0000",
            showLoaderOnConfirm: true,
            preConfirm: (templateId) => {
                return templateId
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {

                try {
                    // console.log("result.value", result.value);
                    // var res = deleteTemplate(result.value);
                    // let objRes = Object.values(res)
                    // console.log(objRes)
                    let inputData = result.value;
                    console.log("inputData:", inputData)       

                    // Genearate necessary params
                    // ----------------------                      
                    if (["weather", "weather forecast"].includes(selectedWidget.name.toLowerCase())){                      
                      extraParams = { ...extraParams,
                                    location : inputData                                    
                                  }
                    }else if (["qr code"].includes(selectedWidget.name.toLowerCase())){
                      const extractedVideoID = extractYouTubeVideoId(inputData);
                      extraParams = { ...extraParams,
                                      colorDark : "#ffffff",
                                      colorLight: "#000000",
                                      ...(extraParams.width >= extraParams.height 
                                          ? {width: extraParams.height, height: extraParams.height}  
                                          : {width: extraParams.width, height: extraParams.width}                                            
                                      ),                                        
                                      url       : inputData ? inputData : "superbolt.com.au",                                                                              
                                    }
                    }else if (["count down"].includes(selectedWidget.name.toLowerCase())){
                      const targetDate = inputData;
                      extraParams = { ...extraParams,
                                      targetDate  : inputData ? inputData : moment().format("YYYY-MM-DD"), //"2025-12-25",
                                      targetTime  : "00:00:00"
                                    }       
                    }else if (["youtube"].includes(selectedWidget.name.toLowerCase())){
                      const extractedVideoID = extractYouTubeVideoId(inputData);
                      extraParams = { ...extraParams,
                                    videoId : extractedVideoID? extractedVideoID : inputData,
                                    autoPlay: 1
                                  }                  
                    }else if (["google sheet"].includes(selectedWidget.name.toLowerCase())){                        
                      let extractedSheetID = inputData.match(/\/d\/e\/(.+)\//)
                      // console.log(extractedSheetID[1])

                      extraParams = { ...extraParams,
                                    sheetId : extractedSheetID? extractedSheetID[1] : inputData,
                                    width   : "100%",
                                    height  : "100%",                                    
                                    showHeader: true, 
                                    showSheet : true,                                    
                                  }
                    }
                    console.log("extraParams:", extraParams)

                    addNewSource(selectedWidget, recentSect, extraParams);

                } catch (error) {
                    Swal.fire(
                        'Unable to do it',
                        'error'
                    )
                }
            }
        })

      }else if(["clock", "time", "date"].includes(selectedWidget.name.toLowerCase())){
        if (["clock"].includes(selectedWidget.name.toLowerCase())){                      
          extraParams = { ...extraParams}
        }else if (["time", "date"].includes(selectedWidget.name.toLowerCase())){
          extraParams = { ...extraParams,
                          fontSize  : "30"
                        }          
        }
        console.log("extraParams:", extraParams)

        addNewSource(selectedWidget, recentSect, extraParams);
      }
  }

  // ----------------------------------
  useEffect(() => {
      window.addEventListener("resize", updatedimensions);
      return () => window.removeEventListener("resize", updatedimensions);
  }, []);
    
  // --------------------------------------------------------
  return (<>
  <div className={`modal fade ${className}`} tabIndex={-1} 
    id='kt_modal_select_widget'
  >
    <div className="modal-dialog modal-lg modal-dialog-centered ">
      <div className="modal-content mh-600px h-475px pb-5">
        <div className='d-flex justify-content-between align-items-center bg-gradient-primary py-2 px-3 rounded-top'>          
          <div className=''>
            <KTSVG path='/media/icons/duotune/general/gen025.svg' className='svg-icon-2x text-light' />              
            <span className='text-light fs-4 ms-2'>Select a Widget</span>
          </div>
          <div className="float-end btn-group btn-group-sm" role="group" >        
              <button
                  className='btn btn-icon btn-close'
                  data-bs-dismiss="modal" 
                  aria-label="Close"
              >                
              </button>
          </div>
        </div>
      <div 
        className='h-100 w-100 px-8 pt-10 pb-5'
        style={{height:"100%", overflowX:"hidden"}}
      >
        <div 
          id="kt_accordion_2" 
          className="accordion accordion-icon-toggle text-center" 
          style={{height:"100%", overflowX:"hidden"}}
        >
          { [...(allWidgets? allWidgets.slice().sort((a, b)=> {            
              if (LIST_PRIORITY.includes(a.name.toLowerCase())){
                return -1;
              }else if(a.name.toLowerCase() > b.name.toLowerCase())
                return 1;
              else{
                return -1;
              }
            }): []),
            ...ADDITIONAL_WIDGETS
            ]
            .map((widget, index) => {
              // console.log(widget.name,"..", getSectionIcon(widget.name.toLowerCase(), "text-white"))
              if (LIST_PRIORITY.includes(widget.name.toLowerCase())){
                return (
                    <button className='btn btn-secondary w-125px h-100px me-4 py-5 px-0 my-2'
                      key={`key-widget-${index}`}
                      data-bs-dismiss="modal"
                      aria-label="Close"

                      onClick={()=> addSelectedWidget(widget)}
                    >
                      <div className='w-100 h-75 d-flex flex-center mb-2'>{getSectionIcon(widget.name.toLowerCase(), "text-gray-700 svg-icon-3x ms-2", "w-50px d-flex flex-center")}</div>
                      <div className='small lh-1 text-capitalize'>{widget.name}</div>
                    </button>
                )              
              }else if (LIST_INTEGRATION.includes(widget.name.toLowerCase())){
                return (
                    <button className='btn btn-secondary w-125px h-100px me-4 p-0 my-2 tooltip-bottom'
                      data-tooltip-content='Available as a custom integration. Submit a ticket to express your interest!'
                      key={`key-widget-${index}`}
                      data-bs-dismiss="modal"
                      aria-label="Close"

                      // data-kt-menu-trigger="{default: 'click'}"                    
                      // data-bs-toggle='modal'
                      // data-bs-target="#kt_modal_edit_widget"
                    >
                      <a href="#" 
                        className='btn btn-secondary w-125px h-100px me-4 py-5 px-0 my-2'
                        key={`key-widget-sub-${index}`}                        
                      
                        data-bs-toggle="offcanvas" 
                        data-bs-target="#kt_drawer_reply_ticket" 
                        data-kt-drawer-show="true"
                      >
                        <div className='w-100 h-75 d-flex flex-center mb-2'>{getSectionIcon(widget.name.toLowerCase(), "text-gray-700 svg-icon-3x ms-2", "w-50px d-flex flex-center")}</div>
                        <div className='small lh-1 text-capitalize'>{widget.name}</div>
                      </a>
                    </button>
                )
              }else{
                return (
                    <button className='btn btn-secondary w-125px h-100px me-4 py-5 px-0 my-2'
                      key={`key-widget-${index}`}
                      data-bs-dismiss="modal"
                      aria-label="Close"

                      data-kt-menu-trigger="{default: 'click'}"                    
                      data-bs-toggle='modal'
                      data-bs-target="#kt_modal_edit_widget"

                      onClick={() => dispatch(setCurrWidget(widget))}
                    >
                      <div className='w-100 h-75 d-flex flex-center mb-2'>{getSectionIcon(widget.name.toLowerCase(), "text-gray-700 svg-icon-3x ms-2", "w-50px d-flex flex-center")}</div>
                      <div className='small lh-1 text-capitalize'>{widget.name}</div>
                    </button>
                )              
              }
            })}            
          </div>
        </div>       
      </div>      
  </div>
</div>
</>
)
}
